import { Estimate } from "./estimate";
import { EstimateType } from "./estimate-type";

export class HazardousMaterialEstimate extends Estimate {
    constructor() {
        super(EstimateType.HazardousMaterial);
    }
    
    public price: number = 0.0;
    public quantity: number = 0;
    public taxPercentage: number = 0.0;
    public description: string = "";
    public override get total(): number { return this.price * this.quantity; }
}